import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Phone, Mail, Menu, X, CalendarDays } from "lucide-react";
import Logo from "./Logo";
import { navItems, siteInfo } from "../mock";
import { useBooking } from "../context/BookingContext";

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const booking = useBooking();

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <header className="bg-white sticky top-0 z-40 border-b border-neutral-200">
      {/* Top bar */}
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 pt-6 pb-3">
        <div className="flex items-center justify-between">
          <Logo />
          <div className="hidden md:flex items-center gap-5">
            <Link
              to="/contact"
              className="text-sm text-neutral-700 hover:text-black transition-colors tracking-wide"
            >
              Contact opnemen
            </Link>
            <button
              onClick={booking.open}
              className="inline-flex items-center gap-2 bg-neutral-900 hover:bg-black text-white px-5 py-2.5 text-sm font-medium transition-colors"
            >
              <CalendarDays size={15} />
              Maak afspraak
            </button>
          </div>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden text-neutral-900 p-2"
            aria-label="Menu"
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Nav bar */}
      <div className="max-w-[1280px] mx-auto px-5 md:px-10 border-t border-neutral-300">
        <div className="hidden md:flex items-center justify-between py-0">
          <nav className="flex items-center">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `px-6 py-4 text-[15px] tracking-wide transition-colors border-r border-neutral-200 last:border-r-0 ${
                    isActive
                      ? "bg-neutral-900 text-white font-medium"
                      : item.highlight
                      ? "text-amber-800 hover:bg-amber-50 font-semibold"
                      : "text-neutral-800 hover:bg-neutral-100"
                  }`
                }
              >
                {item.highlight && (
                  <span className="mr-1.5" aria-hidden="true">⭐</span>
                )}
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-5 text-sm text-neutral-700">
            <a
              href={`mailto:${siteInfo.email}`}
              className="flex items-center gap-2 hover:text-black transition-colors"
            >
              <Mail size={14} />
              {siteInfo.email}
            </a>
            <span className="text-neutral-300">|</span>
            <a
              href={`tel:${siteInfo.phoneRaw}`}
              className="flex items-center gap-2 hover:text-black transition-colors"
            >
              <Phone size={14} />
              {siteInfo.phone}
            </a>
          </div>
        </div>
      </div>

      {/* Mobile nav */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-neutral-200">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `px-6 py-4 text-base tracking-wide border-b border-neutral-100 ${
                    isActive ? "bg-neutral-900 text-white" : item.highlight ? "text-amber-800 font-semibold" : "text-neutral-800"
                  }`
                }
              >
                {item.highlight && <span className="mr-1.5">⭐</span>}
                {item.label}
              </NavLink>
            ))}
            <div className="px-6 py-4 flex flex-col gap-3 text-sm">
              <button
                onClick={() => { booking.open(); setMobileOpen(false); }}
                className="inline-flex items-center justify-center gap-2 bg-neutral-900 hover:bg-black text-white px-5 py-3 text-sm font-medium transition-colors"
              >
                <CalendarDays size={15} />
                Maak een afspraak
              </button>
              <a href={`mailto:${siteInfo.email}`} className="flex items-center gap-2 text-neutral-700">
                <Mail size={14} /> {siteInfo.email}
              </a>
              <a href={`tel:${siteInfo.phoneRaw}`} className="flex items-center gap-2 text-neutral-700">
                <Phone size={14} /> {siteInfo.phone}
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
